<template>
  <div>
    <PriceTableDialogPrice ref="detail" @edit="editar" />
    <el-card shadow="always">
      <el-page-header title="Home" @back="$router.replace({ name: 'home' })"
        :content="$t('cadastro-tabela-preco')"></el-page-header>
    </el-card>
    <el-card>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input :placeholder="$t('pesquisar')" prefix-icon="el-icon-search" v-model="filter"></el-input>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button class="right" type="primary" icon="el-icon-plus" @click="go('adicionar')">{{ $t("adicionar")
          }}</el-button>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button class="right" type="info" icon="el-icon-upload2" @click="go('importar')">{{ $t("importar")
          }}</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData.filter(
          (data) =>
            !filter ||
            data.servicegroupname
              .toLowerCase()
              .includes(filter.toLowerCase()) ||
            data.packagetablename.toLowerCase().includes(filter.toLowerCase())
        )
        " stripe style="width: 100%" cell-class-name="small" :default-sort="{ prop: 'name', order: 'ascending' }">
        <el-table-column sortable prop="packagetablename" :filters="filterPackage" :filter-method="filterHandler"
          :label="$t('pacote')"></el-table-column>
        <el-table-column sortable :label="$t('servico')" :filters="filterService" :filter-method="filterHandler"
          prop="servicegroupname">
        </el-table-column>
        <el-table-column prop="detail" :label="$t('detalhe')">
          <template slot-scope="scope">
            <el-link @click="open(scope.row.packagetableid, scope.row.servicegroupid)">
              <el-tag type="primary" disable-transitions> Ver preços </el-tag>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button type="info" icon="el-icon-edit" @click="
              editar(scope.row.packagetableid, scope.row.servicegroupid)
              " circle></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="
              remove(
                scope.row.packagetableid,
                scope.row.servicegroupid,
                scope.row.packagetablename,
                scope.row.servicegroupname
              )
              " circle></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { PriceTableService } from "@/services/customers/price.table.services";
import { i18n } from "@/plugin/i18n";
import PriceTableDialogPrice from "./PriceTableDialogPrice.vue";

export default {
  name: "PriceTable",
  computed: {
    filterPackage() {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        if (!list.find((x) => x.value === row.packagetablename)) {
          list.push({
            text: row.packagetablename,
            value: row.packagetablename,
          });
        }
      }
      list.sort(function (a, b) {
        if (a.text > b.text)
          return 1;
        if (a.text < b.text)
          return -1;
        return 0;
      });
      return list;
    },
    filterService() {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        if (!list.find((x) => x.value === row.servicegroupname)) {
          list.push({
            text: row.servicegroupname,
            value: row.servicegroupname,
          });
        }
      }
      list.sort(function (a, b) {
        if (a.text > b.text)
          return 1;
        if (a.text < b.text)
          return -1;
        return 0;
      });
      return list;
    },
  },
  methods: {
    open(packagetable, servicegroup) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PriceTableService.findByPackageService(packagetable, servicegroup)
        .then((response) => {
          vm.$refs.detail.open(response)
          vm.packagetable = packagetable;
          vm.servicegroup = servicegroup;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PriceTableService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    go: function (page) {
      var vm = this;
      vm.$router.push(`/cadastro/tabelapreco/${page}`).catch(() => { });
    },
    editar(packagetable, servicegroup) {
      const vm = this;
      this.$router.replace({
        name: "price.table.edit",
        params: { packagetable: packagetable || vm.packagetable, servicegroup: servicegroup || vm.servicegroup },
      });
    },
    remove: function (packagetableid, serviegroupid, packagetablename, serviegroupname) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-tabela-preco", {
        id: `${packagetablename}-${serviegroupname}`,
      }), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PriceTableService.delete(packagetableid, serviegroupid)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("tabela-preco-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      servicegroup: "",
      packagetable: "",
      tableData: [],
      tableDetail: [],
      dialog: { detail: false },
    };
  },
  components: { PriceTableDialogPrice }
};
</script>
<style>
.right {
  float: right;
}

.small {
  font-size: 11px;
}
</style>